@if (isInitialized) {
  <oe-chart [title]="component.alias">
    <oe-controller-heat-chart [isOnlyChart]="true" [component]="component">
    </oe-controller-heat-chart>
  </oe-chart>
}
